import { render } from "./HeaderPracticeMode.vue?vue&type=template&id=160aa099&scoped=true"
import script from "./HeaderPracticeMode.vue?vue&type=script&lang=js"
export * from "./HeaderPracticeMode.vue?vue&type=script&lang=js"

import "@/css/components/c-header-practice-mode.css?vue&type=style&index=0&id=160aa099&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-160aa099"]])

export default __exports__